var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"value":_vm.localTime,"type":"datetime-local","label":_vm.label,"clearable":"","max":_vm.max,"min":_vm.min},on:{"change":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }